import React, { useEffect, useState } from "react";
import ClosedCustomerList from "./ClosedCustomerList.jsx";
import { Api } from "../Api/Api";

const ClosedCustomersPage = () => {
  const [customers, setCustomers] = useState([]); // MUST be []
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadClosedCustomers();
  }, []);

  const loadClosedCustomers = async () => {
    try {
    //   const res = await fetch("http://localhost/erp/customers/list.php");
    const res = await fetch(`${Api}customers/list.php`);

      const data = await res.json();

      const closed = Array.isArray(data?.customers)
        ? data.customers.filter((c) => c.status === "Close")
        : [];

      setCustomers(closed);
    } catch (err) {
      console.error(err);
      setCustomers([]); // SAFETY
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold text-gray-900">Closed Customers</h1>

        {loading ? (
          <div className="p-10 text-center text-gray-500">
            Loading closed customers...
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow border">
            <ClosedCustomerList customers={customers} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ClosedCustomersPage;
